export interface PlaceResult {
  formattedAddress: string;
  address: {
    streetAddress: string;
    city: string;
    zipCode: string;
    state: string;
  };
  location: {
    lat: number;
    long: number;
  };
}

export const DEFAULT_GOOGLE_MAPS_LOGO_SRC =
  '/cmsAssets/assets/img/google-maps/GoogleMaps_Logo_Gray.svg';
